/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "itemizations": {
            "nested": {
              "api": {
                "nested": {
                  "v3": {
                    "nested": {
                      "ActivityType": {
                        "values": {
                          "BOOKED": 1,
                          "PENDING": 2,
                          "FAILED": 3,
                          "CANCELED": 4,
                          "VOIDED": 5,
                          "OPEN": 6,
                          "ATO_FRAUD": 7
                        }
                      },
                      "UserTokens": {
                        "fields": {
                          "merchantToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "unitToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.itemizations?.nested?.api?.nested?.v3?.nested?.ActivityType && !$root.nested?.squareup?.nested?.beemo?.nested?.itemizations?.nested?.api?.nested?.v3?.nested?.UserTokens) {
  $root.addJSON(jsonData);
}

/**
 * This is standalone in case we need to use it in v2 reports.
 *
 * SOURCE ActivityType @ squareup/beemo/v3/reporting_params.proto at 11:1
 */
export const ActivityType = $root.lookupEnum('squareup.beemo.itemizations.api.v3.ActivityType').values;
/**
 * SOURCE UserTokens @ squareup/beemo/v3/reporting_params.proto at 62:1
 */
export const UserTokens = $root.lookupType('squareup.beemo.itemizations.api.v3.UserTokens');
fixType(UserTokens);
Builder.createAndAttachToType(UserTokens);